const achAuthorizationPageDetails = [
  { title: 'ach_authorization__title_1', info: 'ach_authorization__info_1' },
  { title: 'ach_authorization__title_2', info: 'ach_authorization__info_2' },
  { title: 'ach_authorization__title_3', info: 'ach_authorization__info_3' },
  { title: 'ach_authorization__title_4', info: 'ach_authorization__info_4' },
  { title: 'ach_authorization__title_5', info: 'ach_authorization__info_5' },
  { title: 'ach_authorization__title_6', info: 'ach_authorization__info_6' },
  { title: 'ach_authorization__title_7', info: 'ach_authorization__info_7' },
];

export default achAuthorizationPageDetails;
